import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, mergeProps as _mergeProps, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "relative flex w-full max-w-md flex-col gap-5 rounded-xl bg-white p-6 shadow-2xl",
    "data-test": "confirm-modal"
};
const _hoisted_2 = { class: "flex items-center justify-between" };
const _hoisted_3 = { class: "flex items-center gap-3" };
const _hoisted_4 = { class: "text-base font-semibold text-eblack-900" };
const _hoisted_5 = {
    key: 0,
    class: "text-sm text-eblack-600"
};
const _hoisted_6 = {
    key: 1,
    class: "flex flex-col gap-1 text-sm font-medium text-eblack-700"
};
const _hoisted_7 = ["placeholder"];
const _hoisted_8 = { class: "flex items-center justify-end gap-2.5" };
const _hoisted_9 = ["disabled"];
const _hoisted_10 = ["disabled"];
import { ref } from "vue";
import { IconAlertTriangle, IconX } from "@tabler/icons-vue";
export default /*@__PURE__*/ _defineComponent({
    ...{ inheritAttrs: false },
    __name: 'ConfirmModal',
    props: {
        title: {},
        message: { default: "" },
        confirmText: {},
        cancelText: {},
        isConfirming: { type: Boolean, default: false },
        variant: { default: "default" },
        withReason: { type: Boolean, default: false },
        reasonLabel: { default: "" },
        reasonPlaceholder: { default: "" },
        reasonRequired: { type: Boolean, default: false }
    },
    emits: ["confirm", "cancel"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const reason = ref("");
        function handleConfirm() {
            emit("confirm", reason.value);
        }
        function handleCancel() {
            emit("cancel");
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createElementVNode("div", _mergeProps(_ctx.$attrs, { class: "fixed inset-0 z-50 flex items-center justify-center p-4" }), [
                    _createElementVNode("div", {
                        class: "absolute inset-0 bg-black/40",
                        onClick: handleCancel
                    }),
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["flex h-9 w-9 items-center justify-center rounded-full", __props.variant === 'danger' ? 'bg-red-100' : 'bg-eorange-100'])
                                }, [
                                    _createVNode(_unref(IconAlertTriangle), {
                                        class: _normalizeClass(["h-5 w-5", __props.variant === 'danger' ? 'text-red-600' : 'text-eorange-600'])
                                    }, null, 8, ["class"])
                                ], 2),
                                _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.title), 1)
                            ]),
                            _createElementVNode("button", {
                                type: "button",
                                class: "flex h-7 w-7 items-center justify-center rounded-md bg-ewhite-100 text-eblack-400 transition-colors hover:bg-ewhite-200",
                                "data-test": "confirm-modal-close",
                                onClick: handleCancel
                            }, [
                                _createVNode(_unref(IconX), { class: "h-4 w-4" })
                            ])
                        ]),
                        (__props.message)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.message), 1))
                            : _createCommentVNode("", true),
                        (__props.withReason)
                            ? (_openBlock(), _createElementBlock("label", _hoisted_6, [
                                _createTextVNode(_toDisplayString(__props.reasonLabel) + " ", 1),
                                _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((reason).value = $event)),
                                    class: "min-h-20 rounded-md border border-ewhite-200 px-3 py-2 text-sm",
                                    placeholder: __props.reasonPlaceholder,
                                    "data-test": "confirm-modal-reason"
                                }, null, 8, _hoisted_7), [
                                    [
                                        _vModelText,
                                        reason.value,
                                        void 0,
                                        { trim: true }
                                    ]
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "rounded-lg border border-ewhite-300 bg-white px-4 py-2 text-sm font-medium text-eblack-700 transition-colors hover:bg-ewhite-50",
                                disabled: __props.isConfirming,
                                "data-test": "confirm-modal-cancel",
                                onClick: handleCancel
                            }, _toDisplayString(__props.cancelText), 9, _hoisted_9),
                            _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(["flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium text-white transition-colors disabled:opacity-50",
                                    __props.variant === 'danger'
                                        ? 'bg-red-600 hover:bg-red-700'
                                        : 'bg-eblack-900 hover:bg-eblack-800'
                                ]),
                                disabled: __props.isConfirming || (__props.withReason && __props.reasonRequired && !reason.value),
                                "data-test": "confirm-modal-confirm",
                                onClick: handleConfirm
                            }, _toDisplayString(__props.confirmText), 11, _hoisted_10)
                        ])
                    ])
                ], 16)
            ]));
        };
    }
});
